import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Copy } from "@/assets/icons/icons";
import { useAlert } from "@/hooks/useAlert";
import { AlertTypes } from "@/utils/atoms";

interface Props {
  content: string;
  successMessage: string;
  errorMessage: string;
}

export const ClipboardField: FC<Props> = ({
  content,
  successMessage,
  errorMessage,
}) => {
  const showAlert = useAlert();
  const { t } = useTranslation("translation");

  return (
    <button
      type="button"
      className="flex w-full cursor-pointer justify-between gap-5 border-1 border-primary-100 py-3 pl-4 pr-2 text-base text-primary-100"
      aria-label={t("clipboardField.copy")}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(content);
          showAlert({
            type: AlertTypes.info,
            text: successMessage,
          });
        } catch {
          showAlert({
            type: AlertTypes.error,
            text: errorMessage,
          });
        }
      }}
    >
      <span className="overflow-hidden overflow-ellipsis whitespace-nowrap">
        {content}
      </span>
      <Copy className="h-6 w-6 flex-shrink-0" />
    </button>
  );
};
